import React from 'react';

import PropTypes from 'prop-types';

import { MessageDescriptorPropType } from '../../prop-types/intl';
import PrintDocumentActionMenuItem from './action-item';
import PrintDocumentFlyoutMenuItem from './flyout-item';

const PrintDocumentMenuItem = (props) => {
  const { defaultPrintSetting, disabled = false } = props;
  const Component = !defaultPrintSetting || disabled ? PrintDocumentActionMenuItem : PrintDocumentFlyoutMenuItem;

  return <Component {...props} />;
};

PrintDocumentMenuItem.propTypes = {
  defaultPrintSetting: PropTypes.shape({
    messageDescriptor: MessageDescriptorPropType,
    displayText: PropTypes.string,
    onClick: PropTypes.func.isRequired,
  }),
  disabled: PropTypes.bool,
};

export default PrintDocumentMenuItem;
